
export const trackData = {
  init_time: '201807191200',
  points: [
      {
          tau: 0,
          lat: 15.2, lon: 133.5+10, ws: 20,
          radius: {
              r7: [200, 150, 150, 200, 200, 150, 150, 200],
          }
      },
      {
          tau: 12,
          lat: 16.6, lon: 132.8+10, ws: 25,
          radius: {
              r7: [250, 250, 300, 300, 250, 250, 300, 300],
          }
      },
      {
          tau: 24,
          lat: 18.1, lon: 132.1+10, ws: 30,
          radius: {
              r7: [270, 320, 320, 270, 270, 320, 320, 270],
          }
      },
      {
          tau: 48,
          lat: 22.6, lon: 127.9+10, ws: 36,
          radius: {
              r7: [350, 350, 300, 300, 350, 350, 300, 350],
          }
      },
      {
          tau: 72,
          lat: 26.6, lon: 125.1+7, ws: 28,
          radius: {
              r7: [300, 300, 250, 250, 300, 300, 250, 250],
          }
      },
      {
        tau: 96,
        lat: 38.2-6, lon: 122.0+7, ws: 285,
        radius: {
            r7: [280, 240, 240, 280, 280, 240, 240, 280],
        }
      }
  ]
}


export const pastData = {
  points: {
      '201807191200': {
          lat: 15.2, lon: 133.5+10, ws: -9
      },
      '201807190600': {
          lat: 21.2-6, lon: 131.5+13, ws: -9
      },
      '201807190000': {
          lat: 20.5-6, lon: 130.6+13, ws: -9
      },
      '201807181800': {
          lat: 19.6-6, lon: 129.8+13, ws: -9
      }
  }
}


export const iconCase = function(data) {
  let circleColor = '#ff977b';
  let pathColor = '#ff977b';
  let backgroundColor = '#ff977b';
  if (data.ws < 0) {
    circleColor = 'RGBA(255,255,255,0)';
    pathColor = backgroundColor = '#ccc';
  }
  else if (data.ws < 30) {
    circleColor = 'RGBA(255,255,255,0)';
  }

  var icon = L.svgIcon({
      iconUrl: '/images/ty.svg',
      iconSize: [16, 16],
      pathColor: pathColor,
      circleColor: circleColor,
      foregroundColor: '#999999',
      backgroundColor: backgroundColor
  })
  return icon;
};


export const pointInterpolation = function (track_points) {
  let points = track_points
  let op_length = points[points.length - 1].tau - points[0].tau
  let result = []

  let nextPoint = null
  let num = null
  let currPoint = null

  let _do_interp_cnt = null
  let points_tau = points.map(e => e.tau)

  for (let inter_tau of [...Array(op_length + 1).keys()]) {
    let _indexo_points_tau = points_tau.indexOf(inter_tau)

    if (_indexo_points_tau >= 0) {
      currPoint = points[_indexo_points_tau]
      result.push(currPoint)
      nextPoint = points[_indexo_points_tau + 1]
      if (!nextPoint) {
        continue
      }
      num = nextPoint.tau - currPoint.tau
      _do_interp_cnt = 1
    } else {
      let _point = {}
      for (let _property in currPoint) {
        if (['lat', 'lon'].includes(_property)) {
          _point[_property] = currPoint[_property] + ((nextPoint[_property] - currPoint[_property]) / num) * _do_interp_cnt
        } else if (_property !== 'tau') {
          _point[_property] = currPoint[_property]
        } else {
          _point['tau'] = inter_tau
        }
      }
      result.push(_point)
      _do_interp_cnt++
    }
  }
  return result
}
